<template>

    <v-tabs
      class="d-none d-sm-none d-md-flex"
    >
<v-tab :value="homel" @click="$router.push('/')">
<span class="text-regular">L</span><span class="text-attention px-0">.</span>home
</v-tab>
<v-tab value="about" @click="$router.push('/about')">About </v-tab>
<v-tab value="helpl" @click="$router.push('/help')">Help </v-tab>
<v-tab value="rights" @click="$router.push('/rights')">Rights </v-tab>


<v-tab value="contacts" @click="$router.push('/contacts/')">Contacts</v-tab>
<v-tab v-if="$store.state.loggedin" value="login" @click="$router.push('/login')">Login</v-tab>
</v-tabs>
 
<!--mobile version of menu-->
<div>
<v-btn
      color="regular"
      variant="text"
      @click.stop="drawer = !drawer"
      class="d-flex d-sm-none d-none d-sm-flex d-md-none px-2"
    >
      <strong>Menu</strong><svg-icon type="mdi" :path="mdiDotsVertical"/>
</v-btn>
</div>
    <v-navigation-drawer
        v-model="drawer"
        temporary
    >
        <v-tabs
          direction="vertical"
        >
          <v-list >
            <v-tab value="homel" @click="drawer = !drawer, $router.push('/')">
            <span class="text-regular">L</span><span class="text-accent px-0">.</span>home
            </v-tab>
            <v-tab value="about" @click="drawer = !drawer, $router.push('/about')">About </v-tab>
            <v-tab value="helpl" @click="drawer = !drawer, $router.push('/help')">Help </v-tab>
            <v-tab value="rights" @click="drawer = !drawer, $router.push('/rights')">Rights </v-tab>
            
            
        

       

            <v-tab value="contact" @click.stop="$router.push('/contacts'), drawer = !drawer">Contact</v-tab>
            <!-- <v-tab value="login" @click.stop="$router.push('/login'), drawer = !drawer">Login</v-tab> -->
            <!-- <v-tab-- value="service" @click.stop="$router.push('/service'), drawer = !drawer">Service </v-tab--> 
            <!--vuex'ом засунуть вместо "Login" динамику (показывать имя юзера с возможностью выхода или Анон+Логин - если анонимус)-->

          </v-list>  
        </v-tabs>
    </v-navigation-drawer>

<!--end mobile version of menu-->

</template>

<script>
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiDotsVertical } from '@mdi/js';
export default {
  name: 'MainHeader',
  components: {
    SvgIcon,
  },
  data(){ 
    return {
      mdiDotsVertical:mdiDotsVertical,
      drawer: false,
    }
  },



};
</script>